var path = '/app-lite/products/templates/product-search.cell.html';
var html = "<product-search-cell></product-search-cell>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;